import config from "./config";
var axios = config();

export default {
  getCommunityPartner(id) {
    return axios.get("/api/CommunityPartners/" + id);
  },

  getCommunityPartners() {
    return axios.get("/api/CommunityPartners/");
  },

  createCommunityPartner(communityPartner) {
    return axios.post("/api/CommunityPartners/", communityPartner);
  },

  createCommunityPartnerAwards(id, awards) {
    return axios.post("/api/CommunityPartners/" + id + "/awards", awards);
  },

  createCommunityPartnerProposals(id, awards) {
    return axios.post("/api/CommunityPartners/" + id + "/proposals", awards);
  },

  createCommunityPartnerProjects(id, items) {
    return axios.post("/api/CommunityPartners/" + id + "/projects", items);
  },

  updateCommunityPartner(communityPartner) {
    return axios.put(
      "/api/CommunityPartners/" + communityPartner.id,
      communityPartner
    );
  },

  getByTag(tagId) {
    return axios.get("/api/CommunityPartners/tag/" + tagId);
  },

  getCommunityPartnerTypes() {
    return axios.get("/api/CommunityPartnerTypes/");
  },

  // //emails (Jan. 18, 2022)
  // proposalEmail(communityPartnerId) {
  //   // dev hostname: https://api-local.chs.asu.edu:44326/ (from .env.development)
  //   return axios.post(
  //     "/api/CommunityPartners/communityPartners=" + communityPartnerId
  //   );
  // },

  // awardEmail(id) {
  //   return axios.post("/api/summerpayrequests/awardEmail/" + id);
  // },

  // projectEmail(id) {
  //   return axios.post("/api/summerpayrequests/projectEmail/" + id);
  // }
};
